import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * Model description here for TypeScript hints.
 */
export const InitialSyncStoreModel = types
  .model("InitialSyncStore")
  .props({
    synced: types.maybeNull(types.boolean),
    progress: types.optional(types.number, 0)
  })
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key, value) {
      if (key === 'synced') this.setSynced(value)
      else if (key === 'progress') this.setProgress(value)
      else self[key] = value
    },
    setProgress(value) {
      self.progress = value
    },
    setSynced(synced: boolean) {
      self.synced = synced
    },
    init() {
      this.set('progress', 0)
      this.set('synced', false)
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type InitialSyncStoreType = Instance<typeof InitialSyncStoreModel>
export interface InitialSyncStore extends InitialSyncStoreType {}
type InitialSyncStoreSnapshotType = SnapshotOut<typeof InitialSyncStoreModel>
export interface InitialSyncStoreSnapshot extends InitialSyncStoreSnapshotType {}
export const createInitialSyncStoreDefaultModel = () => types.optional(InitialSyncStoreModel, {})
